<div class="footer">
  <div class="footer-content">
    <p class="copyright">&copy; {{ currentYear }} Patient Portal. All rights reserved.</p>
    <div class="footer-links">
      <a routerLink="/privacy">Privacy Policy</a>
      <span class="divider">|</span>
      <a routerLink="/terms">Terms of Service</a>
    </div>
    <p class="powered-by">Powered by <strong>TensorLinks</strong></p>
  </div>
</div>
